import { useAppSelector } from "~/app/store";
import { selectFetchWorkstationsInterval } from "~/features/andon/andon.slice";
import { useGetWorkstationsQuery } from "~/redux/warehouse/workstation.hooks";

export function useWorkstationPolling(): void {
  const pollingInterval = useAppSelector(selectFetchWorkstationsInterval);

  useGetWorkstationsQuery(undefined, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    skipPollingIfUnfocused: true,
    pollingInterval: pollingInterval > 0 ? pollingInterval : undefined
  });
}
